var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ErrorPage',{attrs:{"error-code":_vm.errorCode,"show-support-modal":_vm.shouldShowSupportModal,"data-testid":"error-page"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }